module.exports = __webpack_public_path__ + "img/manager.0454ff6e.png";